export const CONTENT_API = {
  TRANSLATIONS: 'public/concepts/dealerportal/{path}',
  REGION_TRANSLATIONS: 'public/translations/dealer-portal/{region}/all',
  SITEMAP: 'public/sitemap',
  SAFETY_DOCS: 'public/safety-docs/dp-safety-docs/{region}',
  FAQ_SECTIONS: 'public/faq-sections/{directory}',
  FAQ_CONTENT: 'public/faq/{directory}/{sectionKey}',
  DOWNLOAD_LINK: 'download/link/{reference}'
}

export const SALESFORCE_NA = {
  NO_SERIAL_FORM: 'form/case/new'
}

export const SALESFORCE_EMEA = {
  NO_SERIAL_FORM: 's/create-compact-case'
}

export const DPMM_API = {
  REGISTER_SOFTWARE: 'engine_analyzer/authentication',
  RETRIEVE_PASSWORD: 'engine_analyzer/password',
  PRODUCTS_DETAILS: 'product/{serial}/details',
  FAULT_CODES_LIST: 'connected/v3/{serial}/fault_codes',
  AGGREGATED_FAULT_CODES_LIST: 'connected/v3/aggregated/{serial}/fault_codes',
  FAULT_CODES_AUTOCOMPLETE: 'product/fault_codes',
  MACHINE_PASSWORD: 'product/{serial}/password',
  MACHINE_PASSWORD_UPDATE: 'v2/product/{serial}/password/{panel}',
  MACHINE_DATA: 'connected/v3/{serial}',
  LOCATION_DATA: 'connected/v3/{serial}/location',
  MACHINE_SOFTWARE: 'product/{serial}/software/versions',
  SOFTWARE_PAGE: 'content/delivery/dp/software/pages/{page_path}',
  VIDEOS_PAGE: 'content/delivery/service/videos/pages/{page_path}',
  SOFTWARE_PAGENAV: 'content/delivery/dp/software/pagenav/{region}',
  VIDEOS_PAGENAV: 'content/delivery/service/videos/pagenav/{region}',
  MACHINE_HISTORY: 'machine_history/{serial}/sessions',
  CONTROLLERS_DATA: 'connected/v3/{serial}/controllers',
  FAQ_SECTIONS: 'content/faq/{directory}',
  FAQ_CONTENT: 'content/faq/{directory}/section/{sectionKey}',
  WARRANTY_INCLUSIONS: 'equipment/{serial}/warranty_inclusions',
  TROUBLESHOOTING_SESSION_START: 'troubleshooting/{serial}/start/{guide_id}',
  TROUBLESHOOTING_SESSION_RESUME: 'troubleshooting/sessions/{session_id}/resume',
  TROUBLESHOOTING_GUIDES_LIST: 'troubleshooting/guides/serial/{serial}',
  TROUBLESHOOTING_TOP_GUIDES_LIST: 'troubleshooting/guides/serial/{serial}/top',
  TROUBLESHOOTING_SESSION_LIST: 'troubleshooting/sessions/serial/{serial}',
  TROUBLESHOOTING_SETTINGS: 'troubleshooting/settings/serial/{serial}',
  TROUBLESHOOTING_SESSION_SUMMARY: 'troubleshooting/sessions/summary/{session_id}',
  TROUBLESHOOTING_SESSION_SUMMARY_PDF: 'troubleshooting/sessions/summary/{session_id}/pdf',
  TROUBLESHOOTING_USER_SESSION_LIST: 'troubleshooting/userSessions',
  TROUBLESHOOTING_USER_SESSION_STATS: 'troubleshooting/userSessionsStats',
  TROUBLESHOOTING_SESSION_STATS: 'troubleshooting/sessionStats',
  SERVICE_LIBRARY_BULLETINS: 'documents/bulletins/{serial}',
  SERVICE_LIBRARY_LETTERS: 'documents/service_letters/{field_mod_code}',
  SERVICE_LIBRARY_DOCUMENTS: 'documents',
  SERVICE_LIBRARY_MANUALS: 'documents/manuals/{serial}',
  SERVICE_LIBRARY_DOCUMENT_DOWNLOAD: 'documents/{document_id}',
  SERVICE_LIBRARY_REPORT_ERROR: 'service/sl/errors',
  SERVICE_MAINTENANCE_DETAILS: 'product/{serial}/service_details',
  SCHEMATICS_LIST: 'product/{serial}/schematics-v2',
  SCHEMATICS_DETAILS: 'product/{serial}/schematics-v2/{schematic_id}',
  AVAILABLE_REGIONS: 'business_units',
  FEEDBACK_SUBSCRIPTIONS: 'service/usb/subscriptions',
  TROUBLESHOOTING_GUIDE: 'service/troubleshooting/guides',
  LATEST_SOFTWARE: 'software/{software}/latest',
  FEATURE: 'feature/{feature}',
  FEATURES: 'feature',
  OPTIONS_LIST: 'assets/{serial}/options',
  SERVICE_FIELD_MODIFICATIONS: 'assets/{serial}/field_modifications',
  WARRANTY_PLANS: 'assets/{serial}/warranty_plans',
  FAULT_CODE_DETAILS: 'fault_code/{code}/description',
  IDENTITY: 'identity',
  ORG_DESCENDANTS: 'orgselector/descendants',
  SEARCH_CUSTOMER: 'customer/searchByCustomer',
  SEARCH_SERIAL_NUMBER: 'product/customer/{mdmId}',
  WARRANTY_ARTICLES: 'warranty/articles/{region_code}?language_filter={language}'
}

export const MAGNOLIA_AUTHOR = {
  TEMPLATE_DEFINITIONS: '.rest/template-definitions/v1/',
  SOFTWARE_PAGE: '.rest/delivery/dp/software/pages/{page_path}',
  VIDEOS_PAGE: '.rest/delivery/service/videos/pages/{page_path}',
  SOFTWARE_PAGENAV: '.rest/delivery/dp/software/pagenav/{region}',
  VIDEOS_PAGENAV: '.rest/delivery/service/videos/pagenav/{region}',
  CATEGORY: '.rest/delivery/dp/category/dealer-portal/{category}@nodes'
}

export const NGPASSPORT_API = {
  ACTIVE_NOTIFICATIONS: 'v2/announcements/active/app/{appId}?regionCodes={regionCodes}'
}

export const SERVICE_AI = {
  SESSION_CREATE: 'v1/session/create',
  SESSION_STATUS: 'v1/session/status',
  FILE_TYPES: 'v1/session/file/types',
  FILE_UPLOAD_URL: 'v1/session/file/upload/{type}',
  FILE_UPLOAD_STATUS: 'v1/session/file/status/{id}',
  FEEDBACK: 'v1/session/feedback'
}
